module.exports = __webpack_public_path__ + "img/minus.9b0c8d7e.svg";